import styles from './StageInfoModal.module.css';

import Modal from 'ui/Modal';
import RegularButton from 'ui/RegularButton';
import classNames from 'classnames';
import ObjectsInfo from './ObjectsInfo';
import { address_server_short, PUBLIC_ASSETS } from 'config';
import { useMemo } from 'react';
import { ReactComponent as InfoIcon } from 'assets/svg/info_outline.svg';
import Tooltip from 'ui/Tooltip';

const StageInfoModal = ({ setOpen, open, node }) => {
  const closeModal = () => setOpen(false);

  const renderProtocol = useMemo(() => {
    if (!node.protocol || !node.protocol?.operations.length)
      return (
        <div className={styles.protocolError}>
          <InfoIcon className={styles.protocolErrorIcon} />
          <span>{!node.protocol ? 'Инструкция отсутствует' : 'Нет операций'}</span>
        </div>
      );

    return node.protocol?.operations?.map((item, index) => (
      <div className={styles.operation} key={index}>
        <div className={styles.operationNumber}>{index + 1}</div>
        <div className={styles.operationContent}>
          <span className={styles.operationName}>{item.text}</span>
          {item.device_models.length !== 0 && (
            <div className={styles.operationDevices}>
              <div className={styles.operationDevicesList}>
                {item.device_models.map((item, index) => (
                  <Tooltip
                    key={index}
                    text={
                      <div>
                        <span>Параметры: </span>
                        {item.user_fields.map((field, index) => (
                          <div key={index} className={styles.tooltipItem}>
                            <div>{field.name}:</div>
                            <div>{field.value.value || '-'}</div>
                          </div>
                        ))}
                      </div>
                    }
                  >
                    <div className={styles.operationDevicesListItem}>
                      <div className={styles.operationDevicesListItemImageWrapper}>
                        <img
                          src={address_server_short + PUBLIC_ASSETS + item.image}
                          className={classNames(styles.operationDevicesImage)}
                          alt="N/A"
                        />
                      </div>
                      <span>{item.name}</span>
                    </div>
                  </Tooltip>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    ));
  }, [node?.protocol]);

  return (
    <Modal
      hideDefaultFooter={true}
      title="Информация этапа производства"
      onClose={closeModal}
      className={styles.modal}
      open={open}
    >
      <>
        <div className={styles.wrapperInfoModal}>
          <ObjectsInfo objects={node?.objects} childrenArray={node?.children} node={node} />
          {/* <ProtocolInfo operations={node?.operations} usedDevices={node?.used_devices} /> */}
          {node?.used_devices?.length !== 0 && (
            <div className={styles.wrapperUsedDevicesList}>
              <span>Используется: </span>
              <div className={styles.wrapperUsedDevicesMap}>
                {node?.used_devices?.map((device) => (
                  <div className={styles.wrapperUsedDevices} key={device.id}>
                    <div className={styles.operationDevicesImageWrapper}>
                      <img
                        src={address_server_short + PUBLIC_ASSETS + device.image}
                        className={classNames(styles.operationDevicesImage)}
                        alt="N/A"
                      />
                    </div>
                    <span
                      className={classNames(
                        styles.textMain,
                        styles.textOverflow,
                        styles.contentNameModel,
                      )}
                    >
                      {device.model}
                    </span>
                    <span
                      className={classNames(
                        styles.textAuxiliary,
                        styles.textOverflow,
                        styles.contentMain,
                      )}
                    >
                      инв.{device.inventory_number}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className={styles.protocolContainer}>
          <span className={styles.protocolContainerHeader}>Инструкция этапа производства</span>
          {renderProtocol}
        </div>
      </>
      <Modal.Footer>
        <div className={styles.buttonContainer}>
          <RegularButton onClick={closeModal} color="primary" variant="flat" text="Закрыть" />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default StageInfoModal;
